function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.4794426,0 L1.52044265,0 C0.16744265,0 -0.50855735,1.513 0.44844265,2.4 L7.41844265,9.415 C7.79144265,9.79 8.00044265,10.297 8.00044265,10.824 L8.00044265,16.999 C8.00044265,17.313 8.14844265,17.61 8.40044265,17.799 L11.2004426,19.899 C11.5294426,20.146 12.0004426,19.911 12.0004426,19.499 L12.0004426,10.824 C12.0004426,10.297 12.2084426,9.79 12.5814426,9.415 L19.5514426,2.4 C20.5084426,1.513 19.8324426,0 18.4794426,0",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/conversion.127aedf6.svg";
export { SvgComponent as ReactComponent };